import React from 'react';
import { Shield, CheckCircle2 } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 md:py-20 px-4 bg-surface/40 border-y border-zinc-800/60" data-id="element-180">
      <div className="max-w-3xl mx-auto text-center" data-id="element-181">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-primary/10 border-2 border-primary mb-6 shadow-[0_0_40px_rgba(249,168,212,0.35)]" data-id="element-182">
          <Shield className="w-10 h-10 text-primary" data-id="element-183" />
        </div>

        <p className="text-primary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3" data-id="element-184">
          🛡️ Garantía 7 días · Sin preguntas
        </p>

        <h2 className="text-2xl md:text-4xl font-extrabold mb-6 leading-tight" data-id="element-185">
          Probalo 7 días. Si no te sirve,
          <br data-id="element-186" />
          <span className="text-primary" data-id="element-187">te devolvemos el 100%.</span>
        </h2>

        <div className="bg-surface border border-zinc-800 rounded-2xl p-6 md:p-8 text-left space-y-4 text-base md:text-lg text-zinc-300 leading-relaxed" data-id="element-188">
          <p data-id="element-189">
            Abrís los tomos.{' '}
            <span className="text-white font-bold" data-id="element-190">
              Los usás en tus clases.
            </span>
          </p>
          <p data-id="element-191">
            Y si en 7 días sentís que no era lo que esperabas, te devolvemos el
            dinero.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 pt-2" data-id="element-192">
            <div className="flex items-center gap-2 text-white font-bold text-sm md:text-base" data-id="element-193">
              <CheckCircle2 className="w-5 h-5 text-primary shrink-0" data-id="element-194" />
              Sin formularios
            </div>
            <div className="flex items-center gap-2 text-white font-bold text-sm md:text-base" data-id="element-195">
              <CheckCircle2 className="w-5 h-5 text-primary shrink-0" data-id="element-196" />
              Sin vueltas
            </div>
            <div className="flex items-center gap-2 text-white font-bold text-sm md:text-base" data-id="element-197">
              <CheckCircle2 className="w-5 h-5 text-primary shrink-0" data-id="element-198" />
              Un mensaje y listo
            </div>
          </div>
          <p className="pt-2 text-sm text-zinc-400" data-id="element-199">
            Escribís a{' '}
            <span className="text-primary font-bold" data-id="element-200">
              compradigitalyaa@gmail.com
            </span>{' '}
            y resolvemos.
          </p>
        </div>

        <p className="text-base md:text-xl font-bold text-white mt-6" data-id="element-201">
          El riesgo no es tuyo.{' '}
          <span className="text-primary" data-id="element-202">Es nuestro.</span>
        </p>

        <p className="text-xs md:text-sm text-zinc-500 mt-4" data-id="element-203">
          Tasa de devoluciones real: menos del 1%
        </p>
      </div>
    </section>;
}